import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useSelectorProps } from 'hooks';
import { getFormattedSearchParams } from 'selectors';
import FilterCheckboxItem from 'components/FilterCheckboxItem';
import messages from './messages';
import { CheckboxesBlockWrapper, CheckboxesBlockTitle } from './styles';

function FilterCheckboxesBlock(_ref) {
  var block = _ref.block,
      blockItems = _ref.blockItems,
      isWithoutWidth = _ref.isWithoutWidth,
      isCustomTitleMargin = _ref.isCustomTitleMargin;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var selectorProps = useSelectorProps();
  var searchParams = useSelector(function (state) {
    return getFormattedSearchParams(state, selectorProps);
  });
  var check = useCallback(function (blockCheck, item) {
    return Object.keys(searchParams).includes(blockCheck) && searchParams[blockCheck].includes(item);
  }, [searchParams]);
  return /*#__PURE__*/_jsx(CheckboxesBlockWrapper, {
    isWithoutWidth: isWithoutWidth
  }, void 0, /*#__PURE__*/_jsx(CheckboxesBlockTitle, {
    isCustomTitleMargin: isCustomTitleMargin
  }, void 0, formatMessage(messages[block])), blockItems.map(function (item) {
    return /*#__PURE__*/_jsx(FilterCheckboxItem, {
      item: item,
      block: block,
      checked: check(block, item),
      searchParams: searchParams
    }, item);
  }));
}

FilterCheckboxesBlock.defaultProps = {
  isWithoutWidth: false,
  isCustomTitleMargin: false
};
export default /*#__PURE__*/memo(FilterCheckboxesBlock);